import React from 'react';
import { LockIcon } from 'components/icons';
import styles from './geoBlockedService.module.scss';

const GeoBlockedService: React.FC = () => {
  return (
    <div className={styles.container}>
      <LockIcon className={styles.icon} />
      <h2 className={styles.title}>Service Unavailable</h2>
      <p className={styles.description}>This service is not available in your country.</p>
    </div>
  );
};

export default GeoBlockedService;
